import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  employee: People.EmployeeProfileDto;
}

export const EmploymentInfo: React.FC<Props> = ({ employee }) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.root}>
      <Typography gutterBottom variant="h6">
        {t('employmentInfo')}
      </Typography>

      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('legalEntity')}</strong>}:{' '}
        <span data-cy="legal-entity">
          {employee.legalEntity?.name || ' - '}
        </span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('costCenter')}</strong>}:{' '}
        <span data-cy="cost-center">{employee.costCenter?.name || ' - '}</span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('officeLocation')}</strong>}:{' '}
        <span data-cy="office-location">
          {employee.contact.office?.address?.city || ' - '}
        </span>
      </Typography>
    </Box>
  );
};
